import { render, staticRenderFns } from "./inputcontrol.vue?vue&type=template&id=2760b75c&scoped=true&"
import script from "./inputcontrol.vue?vue&type=script&lang=js&"
export * from "./inputcontrol.vue?vue&type=script&lang=js&"
import style0 from "./inputcontrol.vue?vue&type=style&index=0&id=2760b75c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2760b75c",
  null
  
)

export default component.exports